import { Col, Row } from "antd";

import { ToolsMain } from "../../components/custom-tools/tools-main/ToolsMain";
import { DocumentManager } from "../../components/custom-tools/document-manager/DocumentManager";
import { ListOfDocuments } from "./ListOfDocuments";

function GridLayout() {
  return (
    <div className="flex-dir-col overflow-hidden">
      <div className="flex-1 sps-grid-layout overflow-hidden">
        <div className="height-100 overflow-hidden">
          <Row className="height-100 overflow-hidden">
            <Col span={6} className="height-100 overflow-hidden">
              <div className="sps-grid height-100 overflow-hidden">
                <ToolsMain />
              </div>
            </Col>
            <Col
              span={12}
              className="sps-grid-center height-100 overflow-hidden"
            >
              <div className="sps-grid height-100 overflow-hidden">
                <DocumentManager />
              </div>
            </Col>
            <Col span={6} className="height-100">
              <div className="sps-grid height-100">
                <ListOfDocuments />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export { GridLayout };
